import { ToasterService } from '@abp/ng.theme.shared';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  AssetDetailsDto,
  AssetFinancialSummaryDto,
  AssetService,
  AssetType,
  HireAssetFinancialSummaryDto,
} from '@proxy/register-service/assets';
import { IEventConsumable } from '@proxy/register-service/consumables';

@Component({
  selector: 'app-financial-tab',
  templateUrl: './financial-tab.component.html',
  styleUrls: ['./financial-tab.component.scss'],
})
export class FinancialTabComponent implements OnInit {
  @Input() asset: AssetDetailsDto;
  ownedData: AssetFinancialSummaryDto;
  consumptions: IEventConsumable[] = [];
  hiredData: HireAssetFinancialSummaryDto;
  readonly AssetType = AssetType;
  constructor(
    private service: AssetService,
    public readonly router: Router,
    private toasterService: ToasterService
  ) {}

  ngOnInit() {
    if (this.asset.assetType === AssetType.OWNED) {
      this.fetchOwnedData();
    } else {
      this.fetchHiredData();
    }
    this.getConsumables();
  }

  fetchOwnedData(): void {
    if (!this.asset) return;

    this.service.getFinancialInfo(this.asset.id).subscribe({
      next: response => {
        this.ownedData = response;
      },
      error: err => {
        console.error('Error loading asset financial data:', err);
        this.toasterService.error('Something went wrong! Please try again later');
      },
    });
  }

  getTotalCount() {
    return this.consumptions
      ? this.consumptions.reduce((sum, item) => sum + item.count * item.cost, 0)
      : 0;
  }

  getConsumables(): void {
    this.service.getConsumptions(this.asset.id).subscribe({
      next: data => {
        this.consumptions = data;
      },
    });
  }

  fetchHiredData(): void {
    if (!this.asset) return;

    this.service.getHiredFinancialInfo(this.asset.id).subscribe({
      next: response => {
        this.hiredData = response;
      },
      error: err => {
        console.error('Error loading asset financial data:', err);
        this.toasterService.error('Something went wrong! Please try again later');
      },
    });
  }

  onView(id: string) {
    this.router.navigate(['/inspections/details'], {
      queryParams: { id, assetId: this.asset.id },
    });
  }
}
